import $ from 'jquery';
import { createPopper } from '@popperjs/core';
import preventOverflow from '@popperjs/core/lib/modifiers/preventOverflow.js';
import scrollService from '../core/ScrollService.js';
const initTooltips = () => {
    if (document.querySelectorAll('.tooltip')) {
        document.querySelectorAll('.tooltip').forEach((domElt) => {
            domElt.addEventListener('click', (e) => {
                e.preventDefault();
                if (!domElt.classList.contains('visible')) {
                    scrollService.stop();
                    domElt.classList.add('visible');
                    domElt.querySelector('.tooltip_element_scroller').scrollTop = 0;
                    document.addEventListener("click", (event) => {
                        const isClickInside = domElt.contains(event.target);

                        if (!isClickInside) {
                            domElt.classList.remove('visible');
                            scrollService.start();
                        }
                    });
                }
            })
        });
    }
};

export { initTooltips };
